const defaultState = {
    features: [],
};

const mutations = {
    // Set the features state
    setFeaturesState(state, features) {
        state.features = features;
    },
    // Reset the features state
    resetFeaturesState(state) {
        state.features = [];
    },
};

const actions = {
    // Fetch features information
    async getFeaturesInfo({ commit, dispatch }) {
        try {
            const { data } = await this.$rq.getFeatures({}); // Adjust the request method as needed
            commit('setFeaturesState', data);
        } catch (err) {
            dispatch('resetFeaturesInfo');
        }
    },
    // Reset features information
    resetFeaturesInfo({ commit }) {
        commit('resetFeaturesState');
    },
};

const getters = {
    // Getter for the features state
    features: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
